function openCartDrawer(e) {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-item-count").forEach((el) => {
    el.innerText = count;
  });
}
function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    let cartText = form.querySelector("span").innerHTML;

    form.querySelector("span").innerHTML = "Adding to cart...";

    // Submit form with Ajax
    const res = await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    await updateCartDrawer();

    // let cart = await res.json();
    //
    form.querySelector("span").innerHTML = cartText;

    // Open cart drawer
    openCartDrawer(e);
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((el) => {
  el.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();

  const div = document.createElement("div");
  div.innerHTML = text;

  const newBox = div.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;
  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // Close on x
  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement; // how would I do that better?

        // Get new quantity
        const key = rootItem.getAttribute("data-line-item-key");
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value,
        );

        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus",
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        console.log(key);
        console.log(newQuantity);
        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: { [key]: newQuantity },
          }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
      });
      // Get line item key
    });
}

addCartDrawerListeners();
